"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initJsBridge;

require("core-js/modules/es6.regexp.match");

// 调用原生方法
// JS初始化代码

/**
 * 初始化jsbridge
 * @param readyCallback 初始化完成后的回调
 */
function initJsBridge(readyCallback) {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端

  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

  var isApp = !!u.match(/zunaerqjth/); // app端
  // console.log('准备注册')
  // 注册jsbridge

  function connectWebViewJavascriptBridge(callback) {
    if (isAndroid && isApp) {
      // console.log('android开始注册')
      if (window.WebViewJavascriptBridge) {
        // console.log('window.WebViewJavascriptBridge 为true,准备执行回调')
        callback(WebViewJavascriptBridge);
      } else {
        // console.log('window.WebViewJavascriptBridge 为false,准备添加事件监听器')
        // document.addEventListener(
        //   'WebViewJavascriptBridgeReady'
        //   , function() {
        //     callback(WebViewJavascriptBridge)
        //   },
        //   false
        // )
        document.addEventListener('WebViewJavascriptBridgeReady', function (event) {
          if (window.onWebViewJavascriptBridgeReady) window.onWebViewJavascriptBridgeReady(window.__bridge = WebViewJavascriptBridge);
          callback(WebViewJavascriptBridge);
        }, false);
      } // console.log('android注册结束')


      return;
    }

    if (isiOS && isApp) {
      // console.log('ios开始注册')
      // console.log('window.WKWebViewJavascriptBridge', window.WKWebViewJavascriptBridge)
      // console.log('window.WKWVJBCallbacks', window.WKWVJBCallbacks)
      if (window.WKWebViewJavascriptBridge) {
        return callback(WKWebViewJavascriptBridge);
      }

      if (window.WKWVJBCallbacks) {
        return window.WKWVJBCallbacks.push(callback);
      }

      window.WKWVJBCallbacks = [callback]; // console.log('window.WKWVJBCallbacks', window.WKWVJBCallbacks)
      // var WVJBIframe = document.createElement('iframe')
      // WVJBIframe.style.display = 'none'
      // WVJBIframe.src = 'https://__bridge_loaded__'
      // document.documentElement.appendChild(WVJBIframe)
      // setTimeout(function() {
      //   document.documentElement.removeChild(WVJBIframe)
      // }, 0)

      window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null); // console.log('ios注册结束')
    } // console.log('注册结束')

  } // 调用注册方法


  connectWebViewJavascriptBridge(function (bridge) {
    // console.log('准备调用注册方法')
    // console.log(isAndroid && isApp)
    if (isAndroid && isApp) {
      // console.log('安卓注册init')
      if (!window.androidJavascriptInit) {
        window.androidJavascriptInit = true;
        bridge.init(function (message, responseCallback) {
          // console.log('JS got a message', message)
          responseCallback(data);
        });
      }
    }

    readyCallback && readyCallback();
  });
}